import { useEffect } from 'react';
import { Navigation } from '@/components/sections/Navigation';
import { Footer } from '@/components/sections/Footer';
import { BookingGateProvider } from '@/context/BookingGateContext';
import { BookingGateModal } from '@/components/ui/BookingGateModal';
import { HomePage } from '@/pages/HomePage';
import { ContactPage } from '@/pages/ContactPage';
import { PrivacyPage } from '@/pages/PrivacyPage';
import { TermsPage } from '@/pages/TermsPage';
import { applyRouteSeo } from '@/lib/seo';
import { initializeAnalytics, trackPageView } from '@/lib/analytics';

function App() {
  const pathname =
    typeof window !== 'undefined' ? window.location.pathname.replace(/\/+$/, '') || '/' : '/';

  useEffect(() => {
    initializeAnalytics();
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    if (!window.location.hash) {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [pathname]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    applyRouteSeo(pathname);
    trackPageView(pathname);
  }, [pathname]);

  const renderPage = () => {
    if (pathname === '/contact') return <ContactPage />;
    if (pathname === '/privacy') return <PrivacyPage />;
    if (pathname === '/terms') return <TermsPage />;
    return <HomePage />;
  };

  return (
    <BookingGateProvider>
      <div className="min-h-screen bg-bg-primary text-text-primary">
        <Navigation />
        {renderPage()}
        <Footer />
        <BookingGateModal />
      </div>
    </BookingGateProvider>
  );
}

export default App;
